// extracted by mini-css-extract-plugin
module.exports = {"root":"BSqOyLGr","title":"_50mBWxUK","scrollableRoot":"y_sB_OLG","card":"UmqiP5sS"};